import { useState } from "react";

import { CriticalActionForm, PageHeader } from "@/components/admin-ui";
import { adminOpsClient } from "@/lib/api-clients";

export function CreditsPage() {
  const [storeId, setStoreId] = useState("");
  const [amount, setAmount] = useState(100);
  const [result, setResult] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <PageHeader title="เครดิต" />
      <label className="block max-w-md text-sm text-ink">
        Store ID
        <input
          value={storeId}
          onChange={(e) => setStoreId(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-line px-3 py-2"
          placeholder="uuid"
        />
      </label>
      <label className="block max-w-xs text-sm text-ink">
        จำนวน
        <input
          type="number"
          min={1}
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value))}
          className="mt-1 w-full rounded-lg border border-slate-line px-3 py-2"
        />
      </label>
      {storeId ? (
        <>
          <CriticalActionForm
            title="Grant เครดิต"
            targetLabel={storeId}
            currentState="wallet"
            expectedState={`+${amount}`}
            impact="เพิ่มเครดิตแบบ append-only ledger + lot"
            submitLabel="Grant"
            onSubmit={async (payload) => {
              const data = await adminOpsClient.adjustCredit(
                storeId,
                {
                  amount,
                  adjustmentType: "GRANT",
                  reasonCode: payload.reasonCode,
                  reasonText: payload.reasonText,
                },
                crypto.randomUUID(),
              );
              setResult(`GRANT ok · available=${data.availableBalance}`);
            }}
          />
          <CriticalActionForm
            title="Deduct เครดิต"
            targetLabel={storeId}
            currentState="wallet"
            expectedState={`-${amount}`}
            impact="หักเครดิตโดยไม่ให้ติดลบ"
            submitLabel="Deduct"
            onSubmit={async (payload) => {
              const data = await adminOpsClient.adjustCredit(
                storeId,
                {
                  amount,
                  adjustmentType: "DEDUCT",
                  reasonCode: payload.reasonCode,
                  reasonText: payload.reasonText,
                },
                crypto.randomUUID(),
              );
              setResult(`DEDUCT ok · available=${data.availableBalance}`);
            }}
          />
        </>
      ) : null}
      {result ? <p className="text-sm text-success-text">{result}</p> : null}
    </div>
  );
}
